<template>
  <div>
    <Header :current-fortnight="currentFortnight" :previous-fortnight="previousFortnight"
      class="ga-shop-products-header" />
    <v-alert v-if="isWhenAbsent" color="#2A3B4D" dark icon="mdi-firework" dense>
      不在時の納品場所を追加してください。
      <v-text-field class="mt-2" v-model="whenAbsent" solo label="例) 店舗前においてください。" outlined dense></v-text-field>
      <div class="d-flex justify-end">
        <v-btn color="primary" @click="submit">
          登録する
        </v-btn>
      </div>
    </v-alert>
    <alert v-if="!agreeTerms">
      <template v-slot:contents>
        <div class="text-body-1">
          2022年4月15日、<u><a class="d-inline-flex align-baseline" href="https://cavin.ooo/terms-1" target="_blank">
              利用規約<v-icon color="#2196f3" small>mdi-open-in-new</v-icon></a></u>を改定いたしました。
        </div>
        <div class="text-body-1">変更後の内容をご確認いただき、同意される場合は、チェックボックスにチェックを入れて「利用する」ボタンを押してください。</div>
      </template>
      <template v-slot:actions>
        <div class="d-flex flex-column">
          <v-checkbox label="利用規約の内容を確認しました。" v-model="agree" class="ma-0" hide-details />
          <v-btn :disabled="!agree" color="info" outlined class="mt-4" @click="agreetment">利用する</v-btn>
        </div>
      </template>
    </alert>
    <product-filter-mobile @click="onClickSearchHandler" ref="productFilterMobile" :farms="farms"
      :categories="categories" :list="flowers" />

    <div style="text-align: center" id="top">
      <small>{{ $t("welcome") }}</small>、
      <strong>{{ shop.name }}：{{ shop.representative_name }}</strong>
      <small>{{ $t("sama") }}</small>
    </div>

    <ProductContainer>
      <div class="page-title d-flex justify-space-between align-center">
        <div>
          <v-menu transition="slide-y-transition" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small color="white">
                <v-icon>mdi-sort</v-icon>並び替え
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item-group v-model="order">
                <v-list-item value="flower_genus">
                  <v-list-item-title class="ga-shop-products-order-by-genus">品目順</v-list-item-title>
                </v-list-item>
                <v-list-item value="recommend">
                  <v-list-item-title class="ga-shop-products-order-by-recommend">おすすめ順</v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>
        <div>
          <v-btn :color="listView ? '#EEEEEE' : 'white'" @click="() => changeView('grid')" small fab
            class="ga-shop-products-switch-grid-view">
            <v-icon>mdi-view-grid-outline</v-icon>
          </v-btn>
          <v-btn class="ml-2 ga-shop-products-switch-list-view" :color="listView ? 'white' : '#EEEEEE'"
            @click="() => changeView('list')" small fab>
            <v-icon>mdi-format-list-bulleted-square</v-icon>
          </v-btn>
        </div>
      </div>
      <v-divider />
      <div>
        <div class="text-subtitle-2"><span class="text-title-">{{ pagination.total }}</span>件</div>
      </div>
      <div v-if="listView">
        <ProductsList :list="flowers" />
      </div>
      <div v-else class="product-list">
        <ProductCard v-for="flower in flowers" :key="flower.id" :flower="flower" />
        <span v-if="!flowers.length">{{ $t("no_product_found") }}
        </span>
      </div>
      <div class="text-center">
        <v-pagination v-model="page" color="#325146" :length="pagination.length" :total-visible="10"
          @input="paginationHandler" v-scroll-to="'#top'"></v-pagination>
      </div>
    </ProductContainer>
    <NoAreaNotation v-if="shop_default_area_blank" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductContainer from "@/components/shop/products/ProductContainer.vue";
import ProductCard from "@/components/shop/products/ProductCard.vue";
import ProductsList from "@/components/shop/products/ProductsList2.vue";
import NoAreaNotation from "@/components/shop/products/NoAreaNotation.vue";
import ProductFilterMobile from "@/components/shop/products/FilterMobile/index.vue";
import Header from "@/components/shop/products/Header.vue";
import Alert from "@/components/shared/Alert.vue";
import { formatDate } from "@/plugins/i18n";
import sanitizeQueryObject from "@/helpers/sanitizeQueryObject";
import algoliasearch from "algoliasearch";
import algoliasearchHelper from "algoliasearch-helper";

const watchQuery = ["category_id", "flower_genus_id", "farm_id", "delivery_date", "page", "stem_size_min", "stem_size_max", "available", "order"];

export default {
  components: {
    ProductContainer,
    ProductCard,
    Header,
    Alert,
    ProductsList,
    NoAreaNotation,
    ProductFilterMobile
  },
  watchQuery,
  computed: {
    ...mapGetters(["getUserName"]),
    shop() {
      return this.$store.state.user.shop;
    },
    mobile() {
      return this.$vuetify.breakpoint.xs;
    },
    farms() {
      return this.$store.state.searchQuery.available_farms;
    },
    categories() {
      return this.$store.state.searchQuery.categories;
    },
    isWhenAbsent() {
      const whenAbsent = this.$store.state.user.shop.locations?.filter(location => location.default === true)[0].when_absent;
      return !whenAbsent || whenAbsent === "";
    },
    agreeTerms() {
      return this.$store.state.user.agree_terms;
    }
  },

  data() {
    return {
      alert: true,
      flowers: [],
      flowers2: [],
      currentFortnight: 0,
      previousFortnight: 0,
      shop_default_area_blank: true,
      listView: false,
      page: null,
      pagination: {},
      whenAbsent: "",
      available: 0,
      agree: false,
      order: null,
      matcher_ids: []
    };
  },
  async beforeMount() {
    this.listView = await this.$db("shopProductViewType");
  },

  mounted() {
    this.page = this.$route.query.page ? JSON.parse(decodeURIComponent(this.$route.query.page)) : 1;
    this.available = this.$route.query.available ? JSON.parse(decodeURIComponent(this.$route.query.available)) : 0;
  },
  created() {
    this.$store.dispatch("getSearchQuery")
      .then(() => this.initializeProductFilterMobile());
    this.$store.dispatch("getProfile", "shop").then(() => this.fetchHome());
  },
  watch: {
    flowers: {
      handler() { },
      deep: true
    },
    available() {
      const newQuery = new URLSearchParams({ ...this.$route.query, available: this.available });
      this.$router.push(`?${newQuery}`);
      this.fetchHome();
    },
    order() {
      const newQuery = new URLSearchParams({ ...this.$route.query, order: this.order });
      this.$router.push(`?${newQuery}`);
      this.fetchHome();
    }
  },

  methods: {
    onClickSearchHandler(q) {
      this.page = 1;
      const params = { page: this.page, order: this.order };
      if (q.category) params.category_id = q.category.id;
      if (q.genus) params.flower_genus_id = q.genus.id;
      if (q.farm) params.farm_id = q.farm.id;
      if (q.date) params.delivery_date = q.date;
      if (q.stem_size.min) params.stem_size_min = q.stem_size.min;
      if (q.stem_size.max) params.stem_size_max = q.stem_size.max;

      params.available = this.available;

      const query = new URLSearchParams(sanitizeQueryObject(params, watchQuery)).toString();
      this.$router.push(`?${query}`);
      this.fetchHome();
    },
    paginationHandler(number) {
      const query = this.$route.query;
      const newQuery = new URLSearchParams({ ...query, page: number });
      this.$router.push(`?${newQuery}`);
      this.fetchHome(newQuery);
    },
    formatDate(d) {
      return formatDate(d, "yyyy-mm-dd");
    },
    algolia_callback_handler(event) {
      this.flowers = event.results.hits;
      this.pagination.currentPage = event.results.page;
      this.pagination.length = event.results.nbPages;
      this.pagination.total = event.results.nbHits;
    },
    algolia_stem_search_callback_handler(event) {
      console.log("algolia_stem_search_callback_handler");
      const matcher_flowers = event.results.hits;
      const local_matche_ids = matcher_flowers.map(flower => flower.flower_id);
      console.log("local_matche_ids");
      console.log(local_matche_ids);
      if (this.matcher_ids.length > 0) {
        this.matcher_ids = this.matcher_ids.filter(id => local_matche_ids.find(id));
      } else {
        this.matcher_ids = local_matche_ids;
      }
      console.log(this.matcher_ids);
      this.helper.addNumericRefinement("id", "=", this.matcher_ids);
      this.sleep(300);
      this.helper.search();
    },
    algolia_delivery_date_search_callback_handler(event) {
      console.log("algolia_delivery_date_search_callback_handler");
      const local_matche_ids = event.results.hits[0].flowers;
      console.log("local_matche_ids");
      console.log(local_matche_ids);
      if (this.matcher_ids.length > 0) {
        this.matcher_ids = this.matcher_ids.filter(id => local_matche_ids.find(id));
      } else {
        this.matcher_ids = local_matche_ids;
      }
      this.helper.addNumericRefinement("id", "=", this.matcher_ids);
      this.sleep(300);
      this.helper.search();
    },
    async sleep(msec) {
      return new Promise(resolve => setTimeout(resolve, msec));
    },
    async fetchHome() {
      console.log("shop in store is");
      console.dir(this.$store.state);
      console.dir(this.shop);
      if (this.$store.state.user.shop.id) {
        this.sleep(3000);
      }
      this.flowers = [];
      this.matcher_ids = [];
      const params = this.$route.query;
      const client = algoliasearch("1DL6ORBKLX", "613dc024a7fe2f9be133a6aefbb3555d");
      this.helper = algoliasearchHelper(client, "available_flowers");
      if (params.order && params.order === "flower_genus") this.helper = algoliasearchHelper(client, "order_by_flower_genus_id");
      await this.helper.on("result", this.algolia_callback_handler);

      if (params.category_id) this.helper.addNumericRefinement("category_id", "=", params.category_id);
      if (params.flower_genus_id) this.helper.addNumericRefinement("flower_specie.flower_genus.id", "=", params.flower_genus_id);
      if (params.farm_id) this.helper.addNumericRefinement("farm.id", "=", params.farm_id);
      this.helper.addNumericRefinement("user_id", "=", parseInt(this.$store.state.user.shop.id, 10));
      this.helper.setPage(this.page - 1);
      if (params.stem_size_min || params.stem_size_max || params.delivery_date) {
        console.log("params.stem_size_min || params.stem_size_max || params.delivery_date");
        if (params.delivery_date) {
          console.log("to start delivery date mark 1");
          const delivery_date_search_helper = algoliasearchHelper(client, "shop_harvest_delivery_dates_of_a_shop", {
            facets: ["delivery_date"]
          });
          delivery_date_search_helper.addFacetRefinement("delivery_date", params.delivery_date);
          delivery_date_search_helper.addNumericRefinement("shop_id", "=", parseInt(this.$store.state.user.shop.id, 10));
          await delivery_date_search_helper.on("result", this.algolia_delivery_date_search_callback_handler);
          await delivery_date_search_helper.search();
        }
        if (params.stem_size_min) {
          const stem_search_helper = algoliasearchHelper(client, "available_flowers_by_stem_size");
          stem_search_helper.addNumericRefinement("range_min", "=", params.stem_size_min);
          stem_search_helper.addNumericRefinement("range_max", "=", params.stem_size_max);
          await stem_search_helper.on("result", this.algolia_stem_search_callback_handler);
          await stem_search_helper.search();
        }
      } else {
        this.helper.search();
      }
    },
    async agreetment() {
      const res = await this.$http("put", "users/agree_terms");
      if (res.status === 200) { this.$store.state.user.agree_terms = true; }
    },
    changeView(type) {
      this.listView = type === "list";
      this.$db("shopProductViewType", this.listView);
    },
    initializeProductFilterMobile() {
      this.$refs.productFilterMobile.initialize();
    },
    async submit() {
      if (this.whenAbsent) {
        const defaultLocation = this.$store.state.user.shop.locations.find(location => location.default === true);
        await this.$store.dispatch("putLocation", {
          id: defaultLocation.id,
          content: { when_absent: this.whenAbsent }
        }).then(() => {
          this.$store.dispatch("setSnackBar", { msg: "不在時の配送場所を登録しました", color: "green" }, { root: true });
          this.$store.dispatch("snackOn", {}, { root: true });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-title {
  margin: 40px 0 0 0;
  color: #333;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 10px;
}

.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 11px;

  @media only screen and (max-width: 960px) {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }
}

.product-total {
  margin: 10px 10px 10px 10px;
}
</style>
